import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { SOURCES_SERVICE_KEY } from './sourcesEnum.js';

export default getGetterTypesForService(SOURCES_SERVICE_KEY);
